import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CustomToast from '../../../src/components/CustomToast';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // Импортируем иконки из библиотеки react-icons
const Registration = () => {

    // Состояние для управления значениями полей
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [password, setPassword] = useState('');
    const [toastMessage, setToastMessage] = useState(null);
    const [toastType, setToastType] = useState(null);
    const [showPassword, setShowPassword] = useState(false); // Состояние для отображения пароля
    const [inFocus, setFocus] = useState(false)
    const navigate = new useNavigate()
    const apiKey = process.env.REACT_APP_API_KEY;

    useEffect(() => {
        document.title = 'Регистрация';
    }, []);

    const handleButtonClick = async () => {
        const body = {
            email: email,
            firstName: firstName,
            lastName: lastName,
            password: password,
        }
        axios.post(`${apiKey}/autorization/registration`, body)
            .then(response => {
                // Обработка response внутри этого блока
                if (response.status === 200) {
                    setToastType('success');
                    setToastMessage('Для активации аккаунта проверьте почту');
                    setEmail('');
                    setFirstName('');
                    setLastName('');
                    setPassword('');
                }
            }).catch(errors => {
                setToastType('error');
                setToastMessage(errors.response.data.message);
            });
    };


    return (
        <div>
            <div className="App" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <header className="App-header">
                </header>
                <svg className='logo-neon' style={{ width: '200px', height: '200px', margin: '30px 30px 0px 30px' }} xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 37 37">
                    <g clipPath="url(#clip0_6_17)">
                        <path className="path" d="M7.52768 11.9735L3.40221 7.77979C1.13192 10.9045 0 14.4783 0 18.5005C0 22.5226 1.13192 26.0955 3.40221 29.2202L7.43173 25.124C6.22325 23.1753 5.61624 21.0034 5.61716 18.6055C5.61624 16.1851 6.25369 13.9747 7.52675 11.9735H7.52768Z" fill="#B6E33E" />
                        <path className="path" d="M32.9918 7.77979L28.9642 11.8751C30.1726 13.8238 30.7787 15.9975 30.7787 18.3917C30.7769 20.813 30.1422 23.0271 28.8691 25.0283L32.9918 29.2192C35.2621 26.0946 36.3968 22.5198 36.3968 18.4995C36.3968 14.4793 35.2612 10.9045 32.9918 7.77979Z" fill="#B6E33E" />
                        <path className="path" d="M18.0933 31.2878C15.7354 31.2897 13.5988 30.6736 11.6819 29.4432L7.65234 33.5394C10.7271 35.8473 14.2437 36.9998 18.2003 36.9998C22.157 36.9998 25.6699 35.8464 28.7437 33.5394L24.6182 29.3457C22.6496 30.6398 20.4743 31.2869 18.0942 31.2869L18.0933 31.2878Z" fill="#B6E33E" />
                        <path className="path" d="M18.1993 0C14.2427 0 10.7261 1.15347 7.65137 3.4604L11.7759 7.65132C13.7445 6.35719 15.9198 5.71013 18.3036 5.71013C20.6873 5.71013 22.798 6.32531 24.715 7.55567L28.7427 3.4604C25.6689 1.15347 22.1541 0 18.1993 0Z" fill="#B6E33E" />
                        <path className="path" d="M23.6623 9.66305V26.8384H20.8865V20.5816H18.2075L14.1282 26.8384H10.9907L15.2868 20.3359C14.1761 19.9927 13.2629 19.3418 12.547 18.3853C11.8311 17.4288 11.4732 16.3607 11.4732 15.1828C11.4732 13.6458 11.9999 12.3404 13.0544 11.2695C14.1079 10.1985 15.3911 9.66211 16.904 9.66211H23.6623V9.66305ZM16.904 18.0543H20.8865V12.3123H16.904C16.1642 12.3123 15.5359 12.5908 15.0212 13.1469C14.5064 13.703 14.249 14.3819 14.249 15.1837C14.249 15.9855 14.5064 16.6645 15.0212 17.2206C15.5359 17.7767 16.1632 18.0552 16.904 18.0552V18.0543Z" fill="#2C7136" />
                    </g>
                </svg>
                <div className="headerTitle">Регистрация</div>
                <div className='form-container'>
                    <div className="auto-test-container" style={{ marginBottom: "10px" }} >
                        <input
                            className={email !== '' ? 'input-field' : 'input-field-empty'}
                            type="text"
                            value={email}
                            placeholder="Email"
                            onFocus={() => { setFocus(true) }}
                            onBlur={() => { setFocus(false) }}
                            style={{
                                borderColor: email == '' ? 'red' : '', // Изменяем цвет рамки в случае ошибки валидации
                                boxShadow: inFocus && email == '' ? '0 0 5px red' : '',

                            }}
                            onChange={(e) => setEmail(e.target.value)} />
                        <div style={{ position: "relative" }}>
                            <p
                                style={{
                                    color: 'rgb(211, 0, 0)',
                                    fontSize: '12px',
                                    height: '15px',
                                    margin: '0px',
                                    visibility: (email !== '') ? 'hidden' : 'visible',
                                }}
                            >
                                Обязательное поле
                            </p>
                        </div>
                    </div>
                    <div className="auto-test-container" style={{ marginBottom: "10px" }} >
                        <input
                            className={firstName !== '' ? 'input-field' : 'input-field-empty'}
                            type="text"
                            value={firstName}
                            placeholder="Фамилия"
                            onFocus={() => { setFocus(true) }}
                            onBlur={() => { setFocus(false) }}
                            style={{
                                borderColor: firstName == '' ? 'red' : '', // Изменяем цвет рамки в случае ошибки валидации
                                boxShadow: inFocus && firstName == '' ? '0 0 5px red' : '',

                            }}
                            onChange={(e) => setFirstName(e.target.value)} />
                        <div style={{ position: "relative" }}>
                            <p
                                style={{
                                    color: 'rgb(211, 0, 0)',
                                    fontSize: '12px',
                                    height: '15px',
                                    margin: '0px',
                                    visibility: (firstName !== '') ? 'hidden' : 'visible',
                                }}
                            >
                                Обязательное поле
                            </p>
                        </div>
                    </div>
                    <div className="auto-test-container" style={{ marginBottom: "10px" }}>
                        <input
                            className={lastName !== '' ? 'input-field' : 'input-field-empty'}
                            type="text"
                            value={lastName}
                            placeholder="Имя"
                            onFocus={() => { setFocus(true) }}
                            onBlur={() => { setFocus(false) }}
                            style={{
                                borderColor: lastName == '' ? 'red' : '', // Изменяем цвет рамки в случае ошибки валидации
                                boxShadow: inFocus && lastName == '' ? '0 0 5px red' : '',

                            }}
                            onChange={(e) => setLastName(e.target.value)} />
                        <div style={{ position: "relative" }}>
                            <p
                                style={{
                                    color: 'rgb(211, 0, 0)',
                                    fontSize: '12px',
                                    height: '15px',
                                    margin: '0px',
                                    visibility: (lastName !== '') ? 'hidden' : 'visible',
                                }}
                            >
                                Обязательное поле
                            </p>
                        </div>
                    </div>


                    <div className="auto-test-container" style={{ position: 'relative', marginBottom: "10px" }}>
                        <input
                            className={password !== '' ? 'input-field' : 'input-field-empty'}
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            placeholder="Пароль"
                            onFocus={() => { setFocus(true) }}
                            onBlur={() => { setFocus(false) }}
                            style={{
                                borderColor: password == '' ? 'red' : '', // Изменяем цвет рамки в случае ошибки валидации
                                boxShadow: inFocus && password == '' ? '0 0 5px red' : '',

                            }}
                            onChange={(e) => setPassword(e.target.value)} />
                        <span
                            style={{ position: 'absolute', right: '10px', top: '10%', cursor: 'pointer' }}
                            onClick={() => setShowPassword(!showPassword)}>
                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                        </span>
                        <div style={{ position: "relative" }}>
                            <p
                                style={{
                                    color: 'rgb(211, 0, 0)',
                                    fontSize: '12px',
                                    height: '15px',
                                    margin: '0px',
                                    visibility: (password !== '') ? 'hidden' : 'visible',
                                }}
                            >
                                Обязательное поле
                            </p>
                        </div>
                    </div>

                    <div style={{
                        marginTop: '10px'
                    }}>
                        <button
                            onClick={() => {
                                navigate('/authorization')
                            }}
                        >
                            Войти
                        </button>
                        <button
                            onClick={handleButtonClick}
                            style={{
                                marginLeft: '10px'
                            }}
                        >
                            Зарегистрироваться
                        </button>
                    </div>

                </div>

                <CustomToast message={toastMessage} type={toastType} setMessage={setToastMessage} setType={setToastType} />
            </div>
        </div>
    );
};

export default Registration;